var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet-page",class:{ 'loading': _vm.isProcessing }},[_c('div',{class:{ 'loading': _vm.isLoadingChart }},[_c('binary-tree-expandable')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }